import * as React from "react";
import { Fade } from "react-bootstrap";
import { PopupMenuItem } from "../../models/popup";
import { ElementPosition } from "../../models/generic";

interface OwnProps {
    className?: string;
    fadeTimeout?: number;
    id?: string;
    items: PopupMenuItem[];
    onItemClicked: (id?: number) => void;
    pos: ElementPosition;
    processing: boolean;
    loadingIcon?: string;
    selectedIcon?: string;
    show: boolean;
}

interface OwnState {
    fading: boolean;
    isOpen: boolean;
}

export class PopupMenu extends React.Component<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);

        this.state = {
            fading: true,
            isOpen: false,
        };

        this.onEntered = this.onEntered.bind(this);
        this.onExited = this.onExited.bind(this);
        this.onItemClicked = this.onItemClicked.bind(this);
    }

    public onItemClicked(e: React.MouseEvent<HTMLAnchorElement>, item: PopupMenuItem) {
        if (!this.props.processing && !item.checked) {
            if (this.props.onItemClicked)
                this.props.onItemClicked(item.id);
        }

        e.preventDefault();
        return false;
    }

    public onEntered() {
        this.setState({ ...this.state });
    }

    public onExited() {
        this.setState({ ...this.state });
    }

    public render() {
        const checkedIcon = this.props.selectedIcon ? this.props.selectedIcon : "check";
        const loadingIcon = this.props.loadingIcon ? this.props.loadingIcon : "spinner fa-spin";

        const items = this.props.items.map((item, i) => {
            let iconEl = null;
            if (item.selecting && item.selecting && loadingIcon)
                iconEl = <i className={"fa fa-" + loadingIcon}></i>;
            else if (item.checked && checkedIcon)
                iconEl = <i className={"fa fa-" + checkedIcon}></i>;
            return <li key={i}>
                    <a href="#" onClick={(e) => this.onItemClicked(e, item)}>{iconEl}{(iconEl === null ? "" : " ") + item.name}</a>
                </li>;
        });

        return <Fade in={this.props.show} unmountOnExit onEntered={this.onEntered} onExited={this.onExited} timeout={this.props.fadeTimeout || 100} >
                <div
                    className={"dropdown open " + this.props.className}
                    id={this.props.id}
                    aria-expanded style={{ position: "absolute", top: this.props.pos.top, left: this.props.pos.left }}
                >
                    <ul className="dropdown-menu" role="menu">
                        {items}
                    </ul>
                </div>
            </Fade>;
    }
}



// WEBPACK FOOTER //
// ./src/components/generic/PopupMenu.tsx